<template>
    <!-- logo -->
    <img src="/public/assets/logo.png" alt="Logo" class="w-auto" />
</template>
